module.exports = __webpack_public_path__ + "icon-128x128.png";